/**
 * Load table JSON from repo data/tables (alias @data) and pass to createTableStoreFromSources.
 */
import { createTableStoreFromSources } from "@tag-and-tally/shared-ui/logic";

import sceneTables from "@data/tables/scene.json";
import creatureTables from "@data/tables/creature.json";
import characterTables from "@data/tables/character.json";
import woundsTables from "@data/tables/wounds.json";
import gearTables from "@data/tables/gear.json";
import inspirationTables from "@data/tables/inspiration.json";
import questTables from "@data/tables/quest.json";
import hexTables from "@data/tables/hex.json";
import dungeonsTables from "@data/tables/dungeons.json";
import loreTables from "@data/tables/lore.json";
import npcInteractionsTables from "@data/tables/npc-interactions.json";
import fantasyHex from "@data/tables/settings/fantasy/hex.json";
import fantasyDungeon from "@data/tables/settings/fantasy/dungeon.json";
import fantasyNpc from "@data/tables/settings/fantasy/npc.json";
import modernHex from "@data/tables/settings/modern/hex.json";
import modernNpc from "@data/tables/settings/modern/npc.json";
import modernFaction from "@data/tables/settings/modern/faction.json";
import modernDungeon from "@data/tables/settings/modern/dungeon.json";
import monsterHunterNpc from "@data/tables/settings/monster-hunter/npc.json";

const tableSources = [
  { source: "scene", tables: sceneTables },
  { source: "creature", tables: creatureTables },
  { source: "character", tables: characterTables },
  { source: "wounds", tables: woundsTables },
  { source: "gear", tables: gearTables },
  { source: "inspiration", tables: inspirationTables },
  { source: "quest", tables: questTables },
  { source: "hex", tables: hexTables },
  { source: "dungeons", tables: dungeonsTables },
  { source: "lore", tables: loreTables },
  { source: "npc-interactions", tables: npcInteractionsTables },
  { source: "fantasy/hex", tables: fantasyHex },
  { source: "fantasy/dungeon", tables: fantasyDungeon },
  { source: "fantasy/npc", tables: fantasyNpc },
  { source: "modern/hex", tables: modernHex },
  { source: "modern/npc", tables: modernNpc },
  { source: "modern/faction", tables: modernFaction },
  { source: "modern/dungeon", tables: modernDungeon },
  { source: "monster-hunter/npc", tables: monsterHunterNpc },
];

export const webTableStore = createTableStoreFromSources(tableSources);
